export enum ETransfersType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
}

export type TTransfersData = {
  transfer: {
    club: {
      name: string;
      id: number;
    };
    sum: number;
    type: ETransfersType;
    created_at: string;
  };
  user: {
    avatar_url: string;
    phone: string;
    middle_name: string;
    last_name: string;
    first_name: string;
  };
};

export interface IGetTransfersReportResponse {
  depositTransferReport: {
    data: TTransfersData[];
    paginatorInfo: {
      currentPage: number;
      lastPage: number;
    };
    url: string;
  };
}

export interface IGetTransfersReportCSVResponse {
  depositTransferReport: {
    url: string;
  };
}

export interface IGetTransfersReportRequest {
  input: {
    from: string;
    to: string;
    type?: ETransfersType;
    search?: {
      q: string;
    };
  };
  page?: number;
  first?: number;
}

export interface IGetTransfersSummaryReportResponse {
  depositTransferSummaryReport: {
    data: Array<{ values: Array<number> }>;
    extraLabels: Array<string>;
    summary: Array<{
      title: string;
      value: number;
    }>;
  };
}

export interface IGetTransfersSummaryReportRequest {
  input: {
    start: string;
    end: string;
  };
}

export type TNormalizedTransfersSummaryReportData = {
  name: string;
  input: number;
  output: number;
  remains: number;
};
